import React, { FC } from "react";
import classNames from "classnames";
import { twMerge } from "tailwind-merge";
import { Close } from "@app/components/common/icons";
import { Category } from "@app/types/blog";

type Props = {
  categories: Category[];
  selectedLabels: string[];
  onChange: (categoryId: string) => void;
};

export const CategoriesSelect: FC<Props> = ({
  categories,
  selectedLabels,
  onChange,
}) => (
  <div
    className={classNames(
      "mb-15 flex flex-wrap items-center gap-5",
      "lg:mb-22.5",
    )}
  >
    {categories.map((category) => {
      const isSelected = selectedLabels.some(
        (selectedLabel) => selectedLabel === category.uuid,
      );

      return (
        <button
          key={category.uuid}
          className={twMerge(
            classNames(
              "flex items-center gap-3 rounded-full border border-divider px-7 py-2 text-medium text-primary-content duration-300",
              "hover:bg-primary-content/10",
              {
                "border-primary-content": isSelected,
              },
            ),
          )}
          onClick={() => onChange(category.uuid)}
        >
          {category.name}
          {isSelected ? <Close className="h-3.5 w-3.5" /> : null}
        </button>
      );
    })}
  </div>
);
